<template>
  <VDataGridV2
    :loader="dataLoader"
    :context-menu="PackagesService.contextMenu"
    sticky
    entity-type="package"
    @row:dblclick="openPackageCard"
  >
    <VDataGridColumnV2
      id="id"
      label="№"
      width="50px"
      content-align="center"
    >
      <template #default="{ row }">
        <VLink @click="openPackageCard(row)">
          {{ row.id }}
        </VLink>
      </template>
    </VDataGridColumnV2>

    <VDataGridColumnV2
      id="name"
      width="425px"
      label="Название"
      filterable
      filter-send-name="pattern"
      :filter-props="{
        placeholder: 'Название',
        clearable:   true,
      }"
    >
      <template #default="{ row }">
        {{ row.name }}
      </template>
    </VDataGridColumnV2>

    <VDataGridColumnV2
      width="80px"
      content-align="center"
      id="code"
      label="Код"
      filterable
      :filter-props="{
        placeholder: 'Код',
        clearable:   true,
      }"
    >
      <template #default="{ row }">
        {{ row.code }}
      </template>
    </VDataGridColumnV2>

    <VDataGridActionBarV2>
      <VButton
        theme="primary"
        @click="openPackageCard()"
      >
        Добавить упаковку
      </VButton>
    </VDataGridActionBarV2>
  </VDataGridV2>
</template>

<script lang="ts">

import Package            from '@/domains/Packages/Package';
import PackagesService    from '@/domains/Packages/PackagesService';
import DataGridLoader     from '@/lib/components/VDataGridV2/DataGridLoader';

export default defineComponent({
  name: 'PackagesRegistry',

  data() {
    return {
      PackagesService,

      dataLoader: new DataGridLoader(PackagesService.getListPaginated),
    };
  },

  methods: {
    async openPackageCard(row?: Package): Promise<void> {
      if (await PackagesService.showCard(row ?? null)) {
        this.dataLoader.refresh();
      }
    },
  },
});
</script>
